"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var StyleServiceV2_1 = require("@CommonFrontendBackend/StyleServiceV2/StyleServiceV2");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var singleLineString_1 = __importDefault(require("@CommonFrontendBackend/Utils/singleLineString"));
var Animator = (function () {
    function Animator(angularBlockModel, _id, blockStyleStore, $timeout) {
        var _this = this;
        this.angularBlockModel = angularBlockModel;
        this._id = _id;
        this.blockStyleStore = blockStyleStore;
        this.$timeout = $timeout;
        this.turnOffAnimation = function () {
            _this.angularBlockModel.$animationState = "off";
        };
        this.previewAnimation = function () {
            _this.angularBlockModel.$animationState = "hide";
            _this.maybeAddAnimationDelay();
            _this.$timeout(function () {
                _this.angularBlockModel.$animationState = "on";
            }, 100);
        };
        this.maybeAddAnimationDelay = function () {
            var animation = _this.blockStyleStore.getElementStyle("animation");
            var animatableElements = (0, singleLineString_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      .project-block--id-", " .project-block__block-element:not(.project-block__block-element .project-block__block-element):not(.project-block__widget-element .project-block__block-element),\n      .project-block--id-", " .project-block__widget-element\n    "], ["\n      .project-block--id-", " .project-block__block-element:not(.project-block__block-element .project-block__block-element):not(.project-block__widget-element .project-block__block-element),\n      .project-block--id-", " .project-block__widget-element\n    "])), _this._id, _this._id);
            if (animation.animationOption === commonTypes_1.AnimationOption.Section) {
                var viewportHeight_1 = $(window).height();
                var hasReachedEnd_1 = false;
                $(animatableElements).each(function (i, element) {
                    if (hasReachedEnd_1) {
                        return;
                    }
                    var rect = element.getBoundingClientRect();
                    if (rect.top < viewportHeight_1) {
                        $(element)[0].style.animationDelay = "".concat((0, StyleServiceV2_1.getAnimationDelayValue)(animation.speed, i), "s");
                    }
                    else {
                        hasReachedEnd_1 = true;
                    }
                });
            }
            else {
                $(animatableElements).css("animation-delay", "");
            }
        };
    }
    return Animator;
}());
exports.default = Animator;
var templateObject_1;
